import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const ArtCarousel = ({ navigate }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const artworks = [
    {
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/obu63l66_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM.jpeg',
      title: 'Cosmic Dreams',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/yu974o7p_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%281%29.jpeg',
      title: 'Ethereal Journey',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/9ak2x0pb_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%282%29.jpeg',
      title: 'Delicate Forms',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/aoyou4f4_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%283%29.jpeg',
      title: 'Inner Voyage',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/nsi2ouyb_WhatsApp%20Image%202026-04-15%20at%2012.08.22%20PM%20%284%29.jpeg',
      title: 'Misty Solitude',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % artworks.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [artworks.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Digital Art
          </h2>
          <p className="text-gray-600 text-lg">
            Exploring visual narratives through digital illustration
          </p>
        </div>

        {/* Carousel */}
        <div className="relative">
          {/* Main Image */}
          <div className="relative w-full h-[600px] bg-gray-100 rounded-2xl overflow-hidden shadow-2xl">
            {artworks.map((artwork, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentIndex ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img
                  src={artwork.url}
                  alt={artwork.title}
                  className="w-full h-full object-contain"
                />
              </div>
            ))}

            {/* Overlay Title */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-8">
              <h3 className="text-white text-3xl font-bold">
                {artworks[currentIndex].title}
              </h3>
            </div>
          </div>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-3 mt-8">
            {artworks.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentIndex
                    ? 'w-12 h-3 bg-[#EA8649]'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="mt-6 w-full bg-gray-200 rounded-full h-1 overflow-hidden">
            <div
              className="h-full bg-[#EA8649] transition-all duration-100"
              style={{
                width: `${((currentIndex + 1) / artworks.length) * 100}%`,
              }}
            />
          </div>

          {/* View All Button */}
          <div className="text-center mt-8">
            <Button
              onClick={() => navigate('/art')}
              variant="outline"
              className="border-[#EA8649] text-[#EA8649] hover:bg-[#EA8649] hover:text-white"
            >
              View All Artwork
              <ArrowRight className="ml-2" size={18} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtCarousel;
